import * as React from "react";
const SvgFiRrCalendarSalary = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-calendar-salary_svg__a)">
      <path
        fill="#062147"
        d="M24 7v12.126a4.996 4.996 0 0 1-3.751 4.842 1.001 1.001 0 0 1-1.218-.719 1 1 0 0 1 .72-1.217A3 3 0 0 0 22 19.126V10h-3a1 1 0 1 1 0-2h3V7c0-1.654-1.346-3-3-3H5C3.346 4 2 5.346 2 7v1h3a1 1 0 0 1 0 2H2v9.126c0 1.37.925 2.565 2.249 2.906a.999.999 0 1 1-.498 1.936A5 5 0 0 1 0 19.126V7c0-2.757 2.243-5 5-5h1V1a1 1 0 0 1 2 0v1h8V1a1 1 0 1 1 2 0v1h1c2.757 0 5 2.243 5 5m-4.5 9.5a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0M16 18.376a2.616 2.616 0 0 0-2.193-2.588l-3.286-.548a.625.625 0 0 1 .103-1.24h2.644c.356 0 .688.192.867.5a.997.997 0 0 0 1.366.365 1 1 0 0 0 .364-1.366 3.01 3.01 0 0 0-2.598-1.5h-.268a1 1 0 0 0-2 0h-.376a2.627 2.627 0 0 0-2.624 2.624c0 1.288.922 2.377 2.192 2.588l3.286.548a.625.625 0 0 1-.103 1.24H10.73c-.356 0-.688-.192-.867-.5A.999.999 0 1 0 8.132 19.5a3.01 3.01 0 0 0 2.598 1.499h.268a1 1 0 0 0 2 0h.376a2.627 2.627 0 0 0 2.624-2.624z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-calendar-salary_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCalendarSalary;
